// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1VFar","title":"AfterFrontImage_title__3nVgV"};